import React from 'react';
import {Link} from 'react-router-dom';
import {fetchGet} from '../api/config';
const NewsInfo = {
    pageTitle:{
        chinese:'新闻资讯',
        english:'News'
    },
    crumb:{
		home:{
			name:{
				"chinese":"首页",
				"english":"Home"
			},
			url:'/'
		},
		news:{
			name:{
				"chinese":"新闻资讯",
				"english":"News"
			},
			url:'/news'
        },
        text:{
            "chinese":"正文",
            "english":"Text"
        }
   }
}
export default class New extends React.Component{
    state={
        news:{}
    };
	constructor(props){
		super(props);
    }
    componentDidMount() {
       let name = this.props.match.params.id;
	   fetchGet('/new/'+name+'.json',{}).then(data=>{
          if(typeof data == 'object'){
            this.setState({
                news:data
            })
          }
       })
	}
	render(){
        let {news} = this.state;
        const {language} = this.props;
        let  newsContentList = "";
        if(!!news.data){
           newsContentList = news.data.map((data,key)=>
               <div className="news-content-list"  key={key}>
                    <div className={data.title.length>0?'pms-common-title':'hide'}>
                        <span className="pms-square"></span>
                        {data.title}
                    </div>
                    <div className={data.content.length>0?'news-content-paragraph':'hide'}>
                        {data.content.map((data,subkey) =>
                            <p key={subkey}>{data}</p>
                        )}
                    </div>
                    <div className={data.pic.length>0?'news-content-image':'hide'}>
                        <img src={'/article/'+data.pic}/>
                    </div>
                    <div className={data.foot.length>0?'new-content-foot':'hide'}> {data.foot}</div>
                </div>
            )
        }
		return(
			<div className="pms-container pms-news">
				<div className="page-banner">
                    <img src={require('../assets/image/news-banner.png')} alt=""/>
                    <p className="pms-common-title"><span></span> {NewsInfo.pageTitle[language]}</p>
                </div>
				<div className="page-crumbs">
                    <span><Link to="/">{NewsInfo.crumb.home.name[language]}</Link> &gt;</span>
                    <span><Link to="/news/1">{NewsInfo.crumb.news.name[language]}</Link> &gt;</span>
                    <span>{NewsInfo.crumb.text[language]}</span>
                </div>
                <div className="pms-news-container">
                    <div className="pms-news-header">
                        <p className="news-title">{news.title}</p>
                        <p className="news-maintitle">{news.maintitle}</p>
                        <p className="news-time">{news.time}</p>
                    </div>
                    <div className="news-content">
                        {newsContentList}
                    </div>
                </div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./public/views/new.js